import {
  GET_INTERNET_PLAN,
  GET_INTERNET_PLAN_SUCCESS,
  GET_INTERNET_PLAN_FAILURE,
} from '../actions/internetPlan';

const INITIAL_STATE = {
  loading: false,
  requested: false,
  data: null,
  error: null,
};

export default function internetPlan(state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_INTERNET_PLAN:
      return {
        ...state,
        loading: true,
        requested: true,
        error: null,
      };
    case GET_INTERNET_PLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        cacheValid: true,
        data: action.payload,
      };
    case GET_INTERNET_PLAN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
